import React from 'react'
import NibbleBaseInput from '../Inputs/NibbleBaseInput'
import { PropTypes } from 'prop-types';

const FieldsStack = ({ itemsSchema = [], validation, debug = false }) => {
  return (
    <>
      {debug && JSON.stringify(validation?.values)}
      {debug && JSON.stringify(validation?.errors)}

      {itemsSchema.map((item, index) => (
        <NibbleBaseInput
          key={item.name}
          md={item.md}
          label={item.label}
          fieldName={item.name}
          fieldType={item.type}
          validation={validation}
          disabled={item.disabled}
          {...item}
        />
      ))}
    </>
  )
}

FieldsStack.propTypes = {
  itemsSchema: PropTypes .array,
  validation: PropTypes.object,
  debug: PropTypes.bool,
};

export { FieldsStack }
